import * as React from 'react';

import type { DeliverablePost } from 'types';

import CrossButton from 'components/buttons/cross-button/CrossButton';

type Props = {
  post: DeliverablePost,
  onDeletePost?: (a: DeliverablePost) => void
};

class DeliverableMediaLink extends React.PureComponent<Props> {
  handleDelete = (): void => {
    const { post, onDeletePost } = this.props;

    if (onDeletePost) {
      onDeletePost(post);
    }
  };

  render(): React.ReactNode {
    const { post, onDeletePost } = this.props;

    return (
      <div className="deliverable-media-link">
        <div className="deliverable-media-link__container">
          <a
            href={post.url}
            target="_blank"
            rel="noopener noreferrer"
            className="deliverable-media-link__link text-overflow-ellipsis"
            title={post.url}
          >
            {post.url}
          </a>
          {
            onDeletePost &&
              <CrossButton
                type="corner-small"
                onClick={this.handleDelete}
              />
          }
        </div>
      </div>
    );
  }
}

export default DeliverableMediaLink;
